import React from "react";
import styles from "./button.module.css";

const Button = ({ label=null,onClick, ...buttonArgs }) => {
    return (
        <button className={`${styles.button_} ${buttonArgs.buttonOverrideStyle}`}onClick={onClick} {...buttonArgs}  style={buttonArgs?.buttonOverrideInlineStyle} >{label}</button>
    );
};

export default Button;
